const courseTypes = {
  ePub: "ePub",
  bronteViewer: "Bronte Viewer",
  ilab: "ilab",
};
export default courseTypes;